// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_tr-8";
export var editMode = "_tr-3";
export var headerRow = "_tr-a";
export var headerTitle = "_tr-b";
export var product = "_tr-1";
export var productDetails = "_tr-5";
export var productDivider = "_tr-7";
export var productImage = "_tr-2";
export var productInfo = "_tr-4";
export var productTitle = "_tr-6";
export var strikethrough = "_tr-9";
export var upsellProductsCard = "_tr-0";